export default __webpack_public_path__ + "static/media/tersane.4d44a849.jpg";